import { ref } from 'vue';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const presenceChannels = {};
const channels = {};
const echo = ref(null);
const tick = ref(0);

const init = () => {
    if (echo.value) {
        return;
    }
    if (!window.Auth) {
        // eslint-disable-next-line no-console
        console.error('Auth object is not available. Please ensure it is loaded before using sockets.');
        return;
    }
    const pusherConfig = {
        key: window.Auth.pusher.key,
        cluster: window.Auth.pusher.cluster,
        host: window.Auth.pusher.host === 'soketi' ? '127.0.0.1' : window.Auth.pusher.host,
        port: window.Auth.pusher.port,
    };
    echo.value = new Echo({
        broadcaster: 'pusher',
        Pusher,
        key: pusherConfig.key,
        cluster: pusherConfig.cluster,
        wsHost: pusherConfig.host === 'soketi' ? '127.0.0.1' : pusherConfig.host,
        wsPort: pusherConfig.port,
        forceTLS: false,
        encrypted: true,
        enableStats: false,
        enabledTransports: ['ws', 'wss'],
    });
};

const joinPresenceChannel = (channelId) => {
    init();
    if (presenceChannels[`Presence.${channelId}`]) {
        return presenceChannels[`Presence.${channelId}`];
    }
    presenceChannels[`Presence.${channelId}`] = echo.value.join(`Presence.${channelId}`);
    return presenceChannels[`Presence.${channelId}`];
};

const joinChannel = (channelId) => {
    init();
    if (channels[channelId]) {
        return channels[channelId];
    }
    channels[channelId] = echo.value.private(channelId);
    return channels[channelId];
};

const leaveChannel = (channelId) => {
    echo.value.leave(channelId);
    if (channels[channelId]) {
        delete channels[channelId];
    }
};

const leavePresenceChannel = (channelId) => {
    echo.value.leave(`Presence.${channelId}`);
    if (presenceChannels[`Presence.${channelId}`]) {
        delete presenceChannels[`Presence.${channelId}`];
    }
};

export const sockets = {
    tick,
    echo,
    presence: presenceChannels,
    channels,
    joinChannel,
    joinPresenceChannel,
    leaveChannel,
    leavePresenceChannel,
};
